module.exports = __webpack_public_path__ + "img/40_38_027_254.cad87124.jpg";